export default __webpack_public_path__ + "static/media/sendMoney_root_background.ef8bcaba.jpg";